export const PHARMACY_LOCATOR_URL = 'https://www.greencrosshealth.co.nz/locator';
export const PHARMACY_LOCATOR_PAGE_TITLE = 'Pharmacy Locator';
export const SEARCH_BUTTON = 'SEARCH';